import moment from "moment";
import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import XLSX from "xlsx";
import {
  InsertBulkDataIntoETATractor_Aryabhatta,
  GetETATractor_Aryabhatta,
} from "../../../services/tractorEtaDataService";
import { DailyETAReportFilter } from "../../../utils/dataFilter";

function UploadTractorEtaData({
  show,
  handleClose,
  setData,
  setNoDataState,
  date
}) {
  const [planDate, setPlanDate] = useState({
    fromdate: moment().format("YYYY-MM-DD"),
    // todate: moment().format("YYYY-MM-DD"),
  });
  const [excelData, setExcelData] = useState("");
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const readInputFile = (e) => {
    if (e.target.files.length !== 0) {
      var files = e.target.files,
        f = files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        let readedData = XLSX.read(data, { type: "binary", cellDates: true });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        const dataParse = XLSX.utils.sheet_to_json(ws);
        const cleanedData = dataParse.map((row, index) => {
  if (row["Comar Order No."]) {
    const originalValue = row["Comar Order No."];
    const trimmedValue = originalValue.toString().trim();

    // Optional warning if spaces were found
    if (originalValue !== trimmedValue) {
      toast.warn(
        `Extra spaces removed from Comar Order No. at row ${index + 2}`
      );
    }

    return {
      ...row,
      "Comar Order No.": trimmedValue,
    };
  }
  return row;
});
        setExcelData(dataParse);
        const headerDatas = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if ((headerDatas[0][0]) !== ("SAP Sales Order No.")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'SAP Sales Order No.'");
        }
        if ((headerDatas[0][1]) !== ("Comar Order No.")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'Comar Order No.'");
        }
        if ((headerDatas[0][2]) !== ("PY/VY Invoice No.(JD India)")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'PY/VY Invoice No.(JD India)'");
        }
        if ((headerDatas[0][3]) !== ("Internal Reference No.")) {
          setDisableSubmit(true);
          toast.error(
            "Excel Column Heading should be 'Internal Reference No.'"
          );
        }
        if ((headerDatas[0][4]) !== ("Container No.")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'Container No.'");
        }
        if ((headerDatas[0][5]) !== ("BillType")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'BillType'");
        }
        if ((headerDatas[0][6]) !== ("Serial Number of Product")) {
          setDisableSubmit(true);
          toast.error(
            "Excel Column Heading should be 'Serial Number of Product'"
          );
        }
        if ((headerDatas[0][7]) !== ("Material / Service Code (Part No.)")) {
          setDisableSubmit(true);
          toast.error(
            "Excel Column Heading should be 'Material / Service Code (Part No.)'"
          );
        }
        if ((headerDatas[0][8]) !== ("Bill qty")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'Bill qty'");
        }
        if ((headerDatas[0][9]) !== ("Dest Country")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'Dest Country'");
        }
        if ((headerDatas[0][10]) !== ("Destination Port")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'Destination Port'");
        }
        if ((headerDatas[0][11]) !== ("Carrier")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'Carrier'");
        }
        if ((headerDatas[0][12]) !== ("COUNT")) {
          setDisableSubmit(true);
          toast.error("Excel Column Heading should be 'COUNT'");
        }
      };
      reader.readAsBinaryString(f);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);

    const dataReport = await DailyETAReportFilter(
      excelData,
      planDate,
      // containerValue
    );

    if (dataReport.is_valid === true) {
      try {
        if (dataReport.tempData.length > 0) {
          try {
            await InsertBulkDataIntoETATractor_Aryabhatta(dataReport.tempData);
            const response = await GetETATractor_Aryabhatta(date);
            setNoDataState(false);
            setLoading(false);
            setData(response);
            handleClose();

            toast.success("Tractor ETA data uploaded successfully");
          } catch (error) {
            setLoading(false);
            setNoDataState(true);
            toast.error("Unable to upload tractor data");
          }
        }
      } catch (error) {
        setLoading(false);
        toast.error("Unable to upload tractore ETA data");
      }
    } else toast.error("Some columns are missing");
  };

  return (
    <>
      <Modal show={show} backdrop="static" onHide={handleClose} centered>
        <Modal.Body>
          <h4>Upload Tractor ETA File</h4>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Form.Group>
                <Form.Label style={{ fontWeight: "500" }}>Date</Form.Label>
                <Form.Control
                  type="date"
                  className="hiden-inp modal-date-picker-custon"
                  style={{ width: "100%" }}
                  value={planDate.fromdate}
                  onChange={(e) =>
                    setPlanDate({ ...planDate, fromdate: e.target.value })
                  }
                />
              </Form.Group>
            </div>
            {/* <div> */}
            <div></div>
          </div>
          <Form.Group className="mb-3">
            <Form.Control
              type="file"
              className="file-modal-input"
              onChange={(e) => readInputFile(e, "daily")}
            />
          </Form.Group>
          <Button
            className="fr btn-sm"
            onClick={handleSubmit}
            disabled={disableSubmit || loading}
          >
            {loading ? "Uploading" : "Upload"}
          </Button>
          <Button
            className="fr mr-1 btn-sm"
            variant="outline-primary"
            onClick={() => {
              handleClose();
              setExcelData("");
              setDisableSubmit(false);
            }}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UploadTractorEtaData;
